// ============================================================================
// tasks.center — migrated off the global read
// ============================================================================
// /tasks and /tasks/todo: ONE surface, eleven obligations. The Task Center is a
// shell around five INDEPENDENTLY MOUNTED panels — four tabs and the To Do
// list — each with its own load and its own error state, so it is not one
// container load and must not be given one resource. Merging them would fetch
// four tabs (including the admin-only System tab) for every user on every mount.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'tasks.center',
  obligations: Object.freeze([
    Object.freeze({id: 'tasks.center.profiles', owner: 'permanent'}),
    Object.freeze({id: 'tasks.center.mine', owner: 'permanent'}),
    Object.freeze({id: 'tasks.center.recurring', owner: 'permanent'}),
    Object.freeze({id: 'tasks.center.completed', owner: 'permanent'}),
    Object.freeze({id: 'tasks.center.system', owner: 'permanent'}),
    Object.freeze({id: 'tasks.todo.list', owner: 'permanent'}),
    Object.freeze({id: 'tasks.assignable.profiles', owner: 'permanent'}),
    // Descendant interaction reads stay resource-owned without being pulled
    // into the Task Center's normal tab mount.
    Object.freeze({id: 'tasks.instance.interaction.photos', owner: 'permanent'}),
    Object.freeze({id: 'tasks.instance.dueDateHistory', owner: 'permanent'}),
    Object.freeze({id: 'tasks.instance.signedPhotoUrl', owner: 'permanent'}),
    Object.freeze({id: 'tasks.todo.signedPhotoUrl', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
